import styles from './Footer.module.css';
import {translations} from './../i18/translations.js';

const Footer = ({lang}) => {
    return (
            <div className={styles['footer']}>
                <p>&copy; {new Date().getFullYear()} <b>{translations[lang].mbkegy}</b> - {translations[lang].allrightsreserved}!</p>
                <p>{translations[lang].mbkegy_address}</p>
                <p className="mbkegy-content">e-mail: <a className="content-view-link" href="mailto:mbke@ttk.elte.hu">mbke@ttk.elte.hu</a></p>
            </div>
            );
};

export default Footer